import { Button } from '@travelnest/merlin.button';
import React, { useState } from 'react';
import { IEventV2 } from '../../../../data/entities/event';
import { IEventNote, IPendingEventNote } from '../../../../data/entities/event/event-note';
import { applyPending } from '../../../../entities/event-notes';
import { Content } from '../../page/content/Content';
import { EventNotesList } from './EventNotesList';
import { NewEventNote } from './NewEventNoteContainer';

export interface IEventNotesProps {
	event: IEventV2;
	pendingEventNotes: IPendingEventNote[];
	setPending: (pending: boolean) => any;
	deleteEventNote: (EventNote: IEventNote, eventId: string) => void;
}

export const EventNotesComponent: React.FunctionComponent<IEventNotesProps> = (props) => {
	const [editFormExpanded, setEditFormExpanded] = useState(false);
	const toggleEditFormExpanded = () => setEditFormExpanded(!editFormExpanded);
	const eventNotes = props.event.notes || [];
	const allEventNotes = applyPending(props.pendingEventNotes, eventNotes);

	const deleteEventNote = (EventNote: IEventNote) => props.deleteEventNote(EventNote, props.event.id);

	return <Content type="full">
		<div className="event-notes__header">
			<div className="event-notes__title">
				<h2>Notes</h2>
			</div>
			<div className="event-notes__title--button">
				<Button onClick={(e) => toggleEditFormExpanded()}>{editFormExpanded ? 'Close' : 'Add'}</Button>
			</div>
		</div>

		<NewEventNote
			event={props.event}
			expanded={editFormExpanded}
			setPending={props.setPending}
		/>

		<div className="event-notes__row event-notes__row--stacked">
			{allEventNotes.length > 0 ?
				<EventNotesList deleteEventNote={deleteEventNote} eventNotes={allEventNotes} /> :
				null
			}
		</div>
	</Content>;
};
